import React from 'react';

const RandomizeIcon = () => (
  <svg
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20 0.5H4C2.93913 0.5 1.92172 0.921427 1.17157 1.67157C0.421427 2.42172 0 3.43913 0 4.5V20.5C0 21.5609 0.421427 22.5783 1.17157 23.3284C1.92172 24.0786 2.93913 24.5 4 24.5H20C21.0609 24.5 22.0783 24.0786 22.8284 23.3284C23.5786 22.5783 24 21.5609 24 20.5V4.5C24 3.43913 23.5786 2.42172 22.8284 1.67157C22.0783 0.921427 21.0609 0.5 20 0.5ZM9.5 11.5C9.20333 11.5 8.91332 11.412 8.66665 11.2472C8.41997 11.0824 8.22771 10.8481 8.11418 10.574C8.00065 10.2999 7.97094 9.99834 8.02882 9.70736C8.0867 9.41639 8.22956 9.14912 8.43934 8.93934C8.64912 8.72956 8.91639 8.5867 9.20736 8.52882C9.49834 8.47094 9.79994 8.50065 10.074 8.61418C10.3481 8.72771 10.5824 8.91997 10.7472 9.16665C10.912 9.41332 11 9.70333 11 10C11 10.3978 10.842 10.7794 10.5607 11.0607C10.2794 11.342 9.89782 11.5 9.5 11.5ZM14.5 16.5C14.2033 16.5 13.9133 16.412 13.6666 16.2472C13.42 16.0824 13.2277 15.8481 13.1142 15.574C13.0007 15.2999 12.9709 14.9983 13.0288 14.7074C13.0867 14.4164 13.2296 14.1491 13.4393 13.9393C13.6491 13.7296 13.9164 13.5867 14.2074 13.5288C14.4983 13.4709 14.7999 13.5007 15.074 13.6142C15.3481 13.7277 15.5824 13.92 15.7472 14.1666C15.912 14.4133 16 14.7033 16 15C16 15.3978 15.842 15.7794 15.5607 16.0607C15.2794 16.342 14.8978 16.5 14.5 16.5Z"
      fill="white"
    />
  </svg>
);

export default RandomizeIcon;
